/**
 * A lead's address as one line of text.
 *
 * Measured on the live `leads` collection: the address is an OBJECT ({ street, city, state, zip }) on 90.2% of leads, a plain string on
 * under 1%, and absent on the rest. Putting the object into React text or into a text field's state crashes the screen ("Objects are not
 * valid as a React child"), so every lead address that is shown or copied goes through here. Anything that is not a string or an
 * address-shaped object (null, a number, an array, junk) reads as no address, never a throw.
 */
export interface LeadAddressFields {
  readonly street?: unknown;
  readonly city?: unknown;
  readonly state?: unknown;
  readonly zip?: unknown;
}

export type LeadAddress = string | LeadAddressFields | null;

const part = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

export function leadAddressText(address: unknown): string {
  if (typeof address === 'string') return address.trim();
  if (address === null || typeof address !== 'object' || Array.isArray(address)) return '';
  const a = address as LeadAddressFields;
  return [a.street, a.city, a.state, a.zip].map(part).filter(Boolean).join(', ');
}
